exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-dialog .v-card__text[data-v-5a429cfc]{padding:0!important}.v-dialog .v-alert[data-v-5a429cfc]{border-radius:0!important}.v-dialog[data-v-5a429cfc],.v-dialog .v-card__text[data-v-5a429cfc]{overflow:hidden!important}.dialog-message[data-v-5a429cfc]{font-size:.875rem;font-weight:500}", ""]);

// exports
